import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { BadgeModel, PriceViewModel } from 'models/common';
import { RecentlyViewedModel } from 'models';

import { UitkBadge, UitkBadgeTheme } from 'uitk-react-badge';

import { Price } from 'components/common/pricing/price';
import { SupportingMessages } from 'components/search/listing/internals/supporting-messages';

export interface PriceAndSupportingMessagesContainerProps {
  secondaryCardMessage?: string;
  price?: PriceViewModel;
  supportingMessages?: string[];
  viewSmall: boolean;
  wrapPrice: boolean;
  priceFontWeight: string;
  hotelId?: number;
  secondary?: BadgeModel;
  recentlyViewed?: RecentlyViewedModel;
}

export const PriceAndSupportingMessagesContainer: React.FunctionComponent<PriceAndSupportingMessagesContainerProps> = ({
  secondaryCardMessage,
  supportingMessages,
  price,
  viewSmall,
  wrapPrice,
  priceFontWeight,
  hotelId,
  secondary,
  recentlyViewed
}) => {
  const hasSupportingMessages = supportingMessages && supportingMessages.length > 0;

  if (viewSmall) {
    return (
      <div className="uitk-cell all-x-gutter-two uitk-type-right all-cell-shrink listing__pricing">
        <ErrorBoundary label="hotel.search.listing.price">
          {secondaryCardMessage && (
            <span className="secondary-card-message uitk-type-200 uitk-type-medium pwa-theme--grey-900">{secondaryCardMessage}</span>
          )}
          <Price className="listing__price" {...{ price, hotelId, priceFontWeight, wrapPrice, recentlyViewed }} />
          {supportingMessages && supportingMessages.length > 0 && <SupportingMessages supportingMessages={supportingMessages} />}
        </ErrorBoundary>
      </div>
    );
  } else {
    return (
      <div className="uitk-cell all-x-gutter-two uitk-type-right all-cell-shrink">
        {secondary && (secondary.text || secondary.icon) && <UitkBadge theme={UitkBadgeTheme[secondary.theme]} text={secondary.text} />}
        {secondaryCardMessage && (
          <div className="secondary-card-message uitk-type-200 uitk-type-medium pwa-theme--grey-900 all-t-margin-one">
            {secondaryCardMessage}
          </div>
        )}{' '}
        <ErrorBoundary label="hotel.search.listing.price">
          <Price className="listing__price all-t-padding-half" {...{ price, hotelId, priceFontWeight, recentlyViewed }} />
          {hasSupportingMessages && <SupportingMessages supportingMessages={supportingMessages} />}
        </ErrorBoundary>
      </div>
    );
  }
};
